import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

export const publishBusinessPriorities = async (): Promise<void> => {
  const response = await callProcedure<IProcedureResponse<unknown>>({
    url: '/webservice/621/sp/v4/spJBPBusinessPrioritiesPublish/call',
    method: 'POST',
  })

  if ('error' in response) {
    throw response.error
  }
}
